
export default {
  props: {
    question: {
      type: Array,
      default: () => {
        return []
      },
    },
    darkBg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
  },
}
